module.exports = __webpack_public_path__ + "img/GALLERY-SCROSS-5.770dd7cd.jpg";